/**
 * Animace hodnot pod vyhledáváním (na úvodní straně)
 */
function animateValue(obj, start, end, duration) {
	let startTimestamp = null;
	const step = (timestamp) => {
		if (!startTimestamp) startTimestamp = timestamp;
		const progress = Math.min(
			(timestamp - startTimestamp) / duration,
			1
		);
		obj.innerText = Math.floor(progress * (end - start) + start);
		if (progress < 1) {
			window.requestAnimationFrame(step);
		}
	};
	window.requestAnimationFrame(step);
}
export default function () {

	let newOffer = document.querySelector(
		'.richBoxes .newOfferBox .animateClaim .number'
	);
	if (newOffer !== null) {
		let numberNewOffers = newOffer.dataset.number * 1;
		animateValue(
			newOffer,
			0,
			numberNewOffers,
			numberNewOffers < 100 ? 3000 : 5000
		);
	}

	let age = document.querySelector(
		'.richBoxes .ageBox .animateClaim .number'
	);
	if (age !== null) {
		animateValue(age, 0, age.innerText * 1, 3000);
	}

	let connect = document.querySelector(
		'.richBoxes .timeBox .animateClaim .number'
	);
	if (connect !== null) {
		animateValue(connect, 0, connect.innerText * 1, 1000);
	}
}
